import { useEffect, useMemo } from "react";
import { Check, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useCart } from "@/lib/cart";
import { suggestionsFor, combosFor } from "@/lib/combos";
import { AccessoryPicker, forModelOf } from "./AccessoryPicker";

export const CartUpsell = () => {
  const { upsellFor, setUpsellFor, setOpen, catalog, add, has } = useCart();
  const model = upsellFor?.model;
  const list = useMemo(() => (upsellFor && catalog ? suggestionsFor(catalog, model) : []), [catalog, upsellFor, model]);
  const combos = useMemo(() => combosFor(list), [list]);

  useEffect(() => {
    if (!upsellFor || !catalog || list.length) return;
    toast.success(`${upsellFor.model} adicionado ao carrinho`, { action: { label: "Ver carrinho", onClick: () => setOpen(true) } });
    setUpsellFor(null);
  }, [catalog, list, upsellFor, setUpsellFor, setOpen]);

  const isOn = (a) => has(a, forModelOf(a, model));
  const addOne = (a) => { if (!isOn(a)) add(a, forModelOf(a, model), { silent: true }); };
  const close = () => setUpsellFor(null);
  const goCart = () => { close(); setOpen(true); };

  return (
    <Dialog open={!!upsellFor && (!catalog || list.length > 0)} onOpenChange={(v) => !v && close()}>
      <DialogContent data-testid="cart-upsell" className="max-h-[92vh] w-[calc(100%-2rem)] max-w-md gap-0 overflow-hidden rounded-[28px] border-white/10 bg-[#0d0d0f] p-0 text-white">
        <div className="px-6 pb-4 pt-6">
          <p className="flex items-center gap-2 text-sm font-medium text-emerald-300"><Check className="h-4 w-4" /> {model} adicionado</p>
          <DialogTitle className="font-display mt-3 text-2xl font-bold text-white">Complete seu iPhone</DialogTitle>
          <DialogDescription className="mt-1 text-sm text-zinc-400">Acessórios HPrime para o {model}. Combos com 10% off.</DialogDescription>
        </div>
        {!catalog ? <div className="mx-6 h-20 animate-pulse rounded-2xl bg-white/5" /> : (
          <AccessoryPicker list={list} combos={combos} isOn={isOn} onToggle={addOne} onCombo={(c) => c.items.forEach(addOne)} />
        )}
        <div className="mt-4 flex flex-col gap-2 border-t border-white/10 px-6 pb-6 pt-4 sm:flex-row-reverse">
          <button data-testid="upsell-view-cart" onClick={goCart} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-black transition-transform active:scale-95">
            <ShoppingBag className="h-4 w-4" /> Ver carrinho
          </button>
          <button data-testid="upsell-continue" onClick={close} className="flex-1 rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10">
            Continuar comprando
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
